import {h, Fragment, Component} from "preact";
import Ticket from "../utils/ticket-logic.jsx";
import Page from "../../../services/page-data-feed";

import formatOdd from "../../../services/odds-format";

import * as P from "../mobile-templates/ticket";

import {TicketHeader, TicketBody, EndedTicketPopups} from "./ticket-ltn";
import TicketCheckBet from "../desktop-components/ticket-check-bet";
import TicketLoadBet from "../desktop-components/ticket-load-bet";

import { PopupMechanism } from "../../awrabet/mobile-pages/ticket.jsx";

export default class TicketPage extends Component {
	render() {
		return <PopupMechanism 
				   hash="#betslip" 
				   isOpen={e => Page.isMobileTicketOpen()} 
				   onToggle={e => Page.toggleMobileTicket()}
				>
			{({open, onClose}) => open && <P.TicketPopup>
				<TicketContents closePopup={onClose} />
				<div class="h-40"></div>
			</P.TicketPopup>}
		</PopupMechanism>
	}
}

export class TicketContents extends Component {
	render({closePopup}) {
		const eventsList = Ticket.getOdds();
		
		return <Fragment>
			<P.MobileTopRow>
				<TicketHeader closePopup={closePopup} />
			</P.MobileTopRow>
			<TicketBody />
			<EndedTicketPopups />
			<TicketCheckBet />
			<TicketLoadBet />
		</Fragment>;
	}
}


export class TicketOpenButton extends Component {
	render() {
		if (Ticket.isEmpty() || Page.isMobileTicketOpen())
			return null;
		return <OpenTicketButton onClick={e => window.location.hash = '#betslip'} />
	}
}

export const OpenTicketButton = ({onClick}) => <div data-hide="true" class="data-[hide=true]:hidden right-0 bottom-[100px] flex justify-end h-14" onClick={onClick}>
  <TicketSvg class="" />
</div>

export const TicketSvg = ({...props}) => <svg xmlns="http://www.w3.org/2000/svg" class={"h-full fill-current " + props['class']} viewBox="0 0 42.027 15.317">
	<g fill="#db7c2e" stroke-linecap="square" color="#000">
		<path d="M129.88 112.08v13.764h2.252V112.08zm.7.7h.85v12.362h-.85z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
		<path d="M130.23 112.43h1.552v13.064h-1.552z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
	</g>
	<g fill="#fff" stroke-linecap="square" color="#000">
		<path d="M98.705 112.08v13.764h31.873V112.08zm.7.7h30.474v12.362H99.404z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
		<path d="M99.055 112.43h31.173v13.064H99.055z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
	</g>
	<g stroke-linecap="square" color="#000">
		<path fill="#fff" d="M97.762 111.31a7.663 7.663 0 0 0-7.658 7.658 7.663 7.663 0 0 0 7.658 7.658 7.663 7.663 0 0 0 7.658-7.658 7.663 7.663 0 0 0-7.658-7.658zm0 .701a6.95 6.95 0 0 1 6.957 6.957 6.953 6.953 0 0 1-6.957 6.96 6.954 6.954 0 0 1-6.959-6.96 6.952 6.952 0 0 1 6.959-6.957z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
		<path fill="#db7c2e" d="M105.07 118.97a7.308 7.308 0 0 1-7.308 7.308 7.308 7.308 0 0 1-7.309-7.308 7.308 7.308 0 0 1 7.309-7.308 7.308 7.308 0 0 1 7.308 7.308z" style="-inkscape-stroke:none;paint-order:stroke fill markers" transform="translate(-90.103 -111.31)"/>
	</g>
	<g font-family="Roboto">
		<text x="97.763" y="121.749" stroke-width=".16" font-size="6.416" style="line-height:1.25" text-anchor="middle" transform="translate(-90.103 -111.31)">
			<tspan x="97.763" y="121.749">
				{Ticket.countOdds()}
			</tspan>
		</text>
		<text x="105.734" y="117.846" stroke-width=".08" font-size="3.188" style="line-height:1.25" transform="translate(-90.103 -111.31)">
			<tspan x="105.734" y="117.846">
				TOTAL ODDS
			</tspan>
		</text>
		<text x="124.274" y="122.435" stroke-width=".099" font-size="3.976" style="line-height:1.25" text-anchor="end" transform="translate(-90.103 -111.31)">
			<tspan x="124.274" y="122.435">
				{formatOdd(Ticket.getTotalOdds())}
			</tspan>
		</text>
	</g>
</svg>


